// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.App-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: calc(10px + 2vmin);
  color: white;
  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
  position: sticky;
  top: 0;
}
@media screen and (min-width: 0px) {
  .App-header {
    height: 92px;
  }
}
@media screen and (min-width: 667px) {
  .App-header {
    height: 120px;
  }
}
@media screen and (min-width: 900px) {
  .App-header {
    height: 180px;
  }
}
@media screen and (min-width: 1200px) {
  .App-header {
    height: 180px;
  }
}

.Social-btn-container {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;
}
@media screen and (min-width: 0px) {
  .Social-btn-container {
    padding-right: 30px;
  }
}
@media screen and (min-width: 667px) {
  .Social-btn-container {
    width: 100%;
  }
}
@media screen and (min-width: 900px) {
  .Social-btn-container {
    width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  .Social-btn-container {
    width: 100%;
  }
}

.Logo-title {
  font-weight: bold;
  letter-spacing: 1.25px;
  padding-left: 12px;
}

.Logo-icon {
  margin-left: 70px;
  margin-right: 10px;
  border-radius: 50px;
}
@media screen and (min-width: 0px) {
  .Logo-icon {
    width: 36px;
    height: 36px;
  }
}
@media screen and (min-width: 667px) {
  .Logo-icon {
    width: 54px;
    height: 54px;
  }
}
@media screen and (min-width: 900px) {
  .Logo-icon {
    width: 54px;
    height: 54px;
  }
}
@media screen and (min-width: 1200px) {
  .Logo-icon {
    width: 54px;
    height: 54px;
  }
}

.App-store-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 70px;
}
@media screen and (min-width: 0px) {
  .App-store-icon {
    height: 56px;
    width: 168px;
  }
}
@media screen and (min-width: 667px) {
  .App-store-icon {
    height: 46px;
    width: 142px;
  }
}
@media screen and (min-width: 900px) {
  .App-store-icon {
    height: 56px;
    width: 168px;
  }
}
@media screen and (min-width: 1200px) {
  .App-store-icon {
    height: 56px;
    width: 168px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/header.scss"],"names":[],"mappings":"AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EACA,YAAA;EACA,sEAAA;EACA,gBAAA;EACA,MAAA;AAJF;AAME;EAXF;IAYI,YAAA;EAHF;AACF;AAKE;EAfF;IAgBI,aAAA;EAFF;AACF;AAIE;EAnBF;IAoBI,aAAA;EADF;AACF;AAGE;EAvBF;IAwBI,aAAA;EAAF;AACF;;AAGA;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;AAAF;AAEE;EANF;IAOI,mBAAA;EACF;AACF;AACE;EAVF;IAWI,WAAA;EAEF;AACF;AAAE;EAdF;IAeI,WAAA;EAGF;AACF;AADE;EAlBF;IAmBI,WAAA;EAIF;AACF;;AADA;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;AAIF;;AADA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;AAIF;AAFE;EALF;IAMI,WAAA;IACA,YAAA;EAKF;AACF;AAHE;EAVF;IAWI,WAAA;IACA,YAAA;EAMF;AACF;AAJE;EAfF;IAgBI,WAAA;IACA,YAAA;EAOF;AACF;AALE;EApBF;IAqBI,WAAA;IACA,YAAA;EAQF;AACF;;AALA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAQF;AANE;EANF;IAOI,YAAA;IACA,YAAA;EASF;AACF;AAPE;EAXF;IAYI,YAAA;IACA,YAAA;EAUF;AACF;AARE;EAhBF;IAiBI,YAAA;IACA,YAAA;EAWF;AACF;AATE;EArBF;IAsBI,YAAA;IACA,YAAA;EAYF;AACF","sourcesContent":["$extra-small: 0px;\n$small: 667px;\n$medium: 900px;\n$large: 1200px;\n\n.Header-buttons-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.App-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  font-size: calc(10px + 2vmin);\n  color: white;\n  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);\n  position: sticky;\n  top: 0;\n\n  @media screen and (min-width: $extra-small) {\n    height: 92px;\n  }\n\n  @media screen and (min-width: $small) {\n    height: 120px;\n  }\n\n  @media screen and (min-width: $medium) {\n    height: 180px;\n  }\n\n  @media screen and (min-width: $large) {\n    height: 180px;\n  }\n}\n\n.Social-btn-container {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  flex-direction: row;\n\n  @media screen and (min-width: $extra-small) {\n    padding-right: 30px;\n  }\n\n  @media screen and (min-width: $small) {\n    width: 100%;\n  }\n\n  @media screen and (min-width: $medium) {\n    width: 100%;\n  }\n\n  @media screen and (min-width: $large) {\n    width: 100%;\n  }\n}\n\n.Logo-title {\n  font-weight: bold;\n  letter-spacing: 1.25px;\n  padding-left: 12px;\n}\n\n.Logo-icon {\n  margin-left: 70px;\n  margin-right: 10px;\n  border-radius: 50px;\n\n  @media screen and (min-width: $extra-small) {\n    width: 36px;\n    height: 36px;\n  }\n\n  @media screen and (min-width: $small) {\n    width: 54px;\n    height: 54px;\n  }\n\n  @media screen and (min-width: $medium) {\n    width: 54px;\n    height: 54px;\n  }\n\n  @media screen and (min-width: $large) {\n    width: 54px;\n    height: 54px;\n  }\n}\n\n.App-store-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-right: 70px;\n\n  @media screen and (min-width: $extra-small) {\n    height: 56px;\n    width: 168px;\n  }\n\n  @media screen and (min-width: $small) {\n    height: 46px;\n    width: 142px;\n  }\n\n  @media screen and (min-width: $medium) {\n    height: 56px;\n    width: 168px;\n  }\n\n  @media screen and (min-width: $large) {\n    height: 56px;\n    width: 168px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
